export const appRootId = "app"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[],"style":[],"script":[{"async":true,"src":"https://www.googletagmanager.com/gtag/js?id=G-SXRCQMGX7R"},{"id":"gtag-init","innerHTML":"\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag('js', new Date());\n\n              gtag('config', 'G-SXRCQMGX7R');\n            ","type":"text/javascript"},{"id":"yandex-metrika","innerHTML":"\n              (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n              m[i].l=1*new Date();\n              for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n              k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n              (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n              ym(102909195, \"init\", {\n                  clickmap:true,\n                  trackLinks:true,\n                  accurateTrackBounce:true,\n                  webvisor:true\n              });\n            ","type":"text/javascript"},{"id":"meta-pixel","innerHTML":"\n              !function(f,b,e,v,n,t,s)\n              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n              n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n              n.queue=[];t=b.createElement(e);t.async=!0;\n              t.src=v;s=b.getElementsByTagName(e)[0];\n              s.parentNode.insertBefore(t,s)}(window, document,'script',\n              'https://connect.facebook.net/en_US/fbevents.js');\n              fbq('init', '2052796785490488');\n              fbq('track', 'PageView');\n            ","type":"text/javascript"},{"src":"https://telegram.org/js/telegram-web-app.js","async":true,"defer":true,"onload":"window.telegramWebAppLoaded = true;","onerror":"console.warn('Telegram Web App script failed to load');"}],"noscript":[{"children":"<div><img src=\"https://mc.yandex.ru/watch/102909195\" style=\"position:absolute; left:-9999px;\" alt=\"\" /></div>","tagPosition":"bodyClose"},{"children":"<img height=\"1\" width=\"1\" style=\"display:none\" src=\"https://www.facebook.com/tr?id=2052796785490488&ev=PageView&noscript=1\" />","tagPosition":"bodyClose"}],"__dangerouslyDisableSanitizersByTagID":{"gtag-init":["innerHTML"],"yandex-metrika":["innerHTML"],"meta-pixel":["innerHTML"]}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootTag = "div"

export const appRootAttrs = {"id":"app"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#app'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false